// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bUJ5","header":"ReportDetails_header__2jWYt","title":"ReportDetails_title__1N2Sd","left":"ReportDetails_left__3eyRG"};